export const mapStringHelper = (str: string) => ({ label: str, value: str });
